import { SET_AMBASSADOR_LIST, } from "./types";

const initialState = {
    list: [],
    count: 0
};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_AMBASSADOR_LIST:
            return {
                ...state,
                list: action.data.list,
                count: action.data.count,
            }
        default:
            return state;
    }
}